import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "persistent-menu row no-wrap items-end justify-between" }
const _hoisted_2 = {
  key: 1,
  style: {"width":"72px"}
}
const _hoisted_3 = { class: "row items-end q-mr-md full-width" }
const _hoisted_4 = { class: "brending q-mr-sm q-mb-sm" }
const _hoisted_5 = ["textContent", "href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_burger_button = _resolveComponent("burger-button")!
  const _component_persistent_button = _resolveComponent("persistent-button")!
  const _component_persistent_answer_field = _resolveComponent("persistent-answer-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.persistentMenu.length > 0)
      ? (_openBlock(), _createBlock(_component_burger_button, {
          key: 0,
          active: _ctx.menuOpened,
          onActive: _cache[0] || (_cache[0] = (active) => (_ctx.menuOpened = active)),
          class: "burger"
        }, null, 8, ["active"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2)),
    (_ctx.menuOpened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "buttons-wrap",
          style: _normalizeStyle({ marginBottom: _ctx.isShowAnswerField ? '48px' : '0px' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persistentMenu, (button, index) => {
            return (_openBlock(), _createBlock(_component_persistent_button, {
              key: index,
              button: button,
              onClick: ($event: any) => (_ctx.clickOnButton(button))
            }, null, 8, ["button", "onClick"]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createTextVNode(" Powered by ")),
        _createElementVNode("a", {
          textContent: _toDisplayString(_ctx.poweredBy),
          href: _ctx.href,
          target: "_blank",
          class: "text-primary"
        }, null, 8, _hoisted_5)
      ], 512), [
        [_vShow, _ctx.isShowBranding]
      ]),
      _createVNode(_Transition, { name: "answer-field" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_persistent_answer_field, {
            class: "answer-field q-mb-sm q-px-sm",
            onInputValue: _ctx.sendMessage
          }, null, 8, ["onInputValue"]), [
            [_vShow, _ctx.isShowAnswerField]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}